export const polygons = {
  moscow: {
    cyrillicName: 'москва',
    paths: [
      { lat: 55.714051, lng: 37.386218 },
      { lat: 55.746143, lng: 37.369051 },
      { lat: 55.785931, lng: 37.369738 },
      { lat: 55.790756, lng: 37.373171 },
      { lat: 55.799248, lng: 37.381754 },
      { lat: 55.806195, lng: 37.387248 },
      { lat: 55.823556, lng: 37.392741 },
      { lat: 55.837825, lng: 37.396174 },
      { lat: 55.842259, lng: 37.394801 },
      { lat: 55.846885, lng: 37.391367 },
      { lat: 55.852282, lng: 37.393427 },
      { lat: 55.858641, lng: 37.397204 },
      { lat: 55.865962, lng: 37.40304 },
      { lat: 55.872319, lng: 37.41437 },
      { lat: 55.875208, lng: 37.423296 },
      { lat: 55.878868, lng: 37.435999 },
      { lat: 55.881756, lng: 37.445269 },
      { lat: 55.882719, lng: 37.453852 },
      { lat: 55.883297, lng: 37.465182 },
      { lat: 55.88657, lng: 37.479258 },
      { lat: 55.889073, lng: 37.489214 },
      { lat: 55.896581, lng: 37.506381 },
      { lat: 55.90505, lng: 37.526293 },
      { lat: 55.906782, lng: 37.532473 },
      { lat: 55.911401, lng: 37.576418 },
      { lat: 55.910439, lng: 37.587061 },
      { lat: 55.90659, lng: 37.600451 },
      { lat: 55.902933, lng: 37.613841 },
      { lat: 55.898506, lng: 37.63753 },
      { lat: 55.896004, lng: 37.659846 },
      { lat: 55.895234, lng: 37.685595 },
      { lat: 55.894849, lng: 37.694865 },
      { lat: 55.891961, lng: 37.706538 },
      { lat: 55.851704, lng: 37.785845 },
      { lat: 55.82857, lng: 37.830821 },
      { lat: 55.823363, lng: 37.836314 },
      { lat: 55.81777, lng: 37.838374 },
      { lat: 55.785737, lng: 37.841807 },
      { lat: 55.758162, lng: 37.842837 },
      { lat: 55.739805, lng: 37.841464 },
      { lat: 55.714865, lng: 37.83803 },
      { lat: 55.711963, lng: 37.837687 },
      { lat: 55.700164, lng: 37.830821 },
      { lat: 55.691456, lng: 37.829447 },
      { lat: 55.676166, lng: 37.834597 },
      { lat: 55.665517, lng: 37.838374 },
      { lat: 55.660869, lng: 37.839404 },
      { lat: 55.655834, lng: 37.838374 },
      { lat: 55.645179, lng: 37.827044 },
      { lat: 55.632196, lng: 37.806101 },
      { lat: 55.619597, lng: 37.785159 },
      { lat: 55.603696, lng: 37.756663 },
      { lat: 55.592446, lng: 37.73057 },
      { lat: 55.57634, lng: 37.688342 },
      { lat: 55.573623, lng: 37.679759 },
      { lat: 55.57207, lng: 37.673235 },
      { lat: 55.572847, lng: 37.652636 },
      { lat: 55.575176, lng: 37.611094 },
      { lat: 55.576146, lng: 37.593928 },
      { lat: 55.584491, lng: 37.557536 },
      { lat: 55.596132, lng: 37.510844 },
      { lat: 55.633359, lng: 37.465525 },
      { lat: 55.660482, lng: 37.434283 },
    ],
  },
  moscow1: {
    cyrillicName: 'Москва 1',
    paths: [
      { lng: 37.391409, lat: 55.924553 },
      { lng: 37.415442, lat: 55.957624 },
      { lng: 37.479987, lat: 55.972228 },
      { lng: 37.529425, lat: 55.97607 },
      { lng: 37.58779, lat: 55.966848 },
      { lng: 37.646841, lat: 55.957624 },
      { lng: 37.695593, lat: 55.959162 },
      { lng: 37.749838, lat: 55.957624 },
      { lng: 37.793097, lat: 55.96339 },
      { lng: 37.841162, lat: 55.964927 },
      { lng: 37.870001, lat: 55.95032 },
      { lng: 37.878928, lat: 55.933015 },
      { lng: 37.872748, lat: 55.918397 },
      { lng: 37.860388, lat: 55.903387 },
      { lng: 37.867941, lat: 55.888757 },
      { lng: 37.931113, lat: 55.852929 },
      { lng: 37.981238, lat: 55.841365 },
      { lng: 37.987418, lat: 55.825554 },
      { lng: 37.994971, lat: 55.78851 },
      { lng: 38.019003, lat: 55.753748 },
      { lng: 38.036856, lat: 55.727463 },
      { lng: 38.004584, lat: 55.7 },
      { lng: 37.963385, lat: 55.674066 },
      { lng: 37.948279, lat: 55.643853 },
      { lng: 37.92356, lat: 55.627187 },
      { lng: 37.877554, lat: 55.608575 },
      { lng: 37.79859, lat: 55.570159 },
      { lng: 37.776617, lat: 55.555792 },
      { lng: 37.696967, lat: 55.526265 },
      { lng: 37.641348, lat: 55.512271 },
      { lng: 37.559637, lat: 55.520046 },
      { lng: 37.511572, lat: 55.532872 },
      { lng: 37.449774, lat: 55.557734 },
      { lng: 37.396216, lat: 55.579476 },
      { lng: 37.35433, lat: 55.614004 },
      { lng: 37.309012, lat: 55.624473 },
      { lng: 37.2582, lat: 55.640753 },
      { lng: 37.173056, lat: 55.629125 },
      { lng: 37.168249, lat: 55.667483 },
      { lng: 37.192282, lat: 55.696904 },
      { lng: 37.180609, lat: 55.730655 },
      { lng: 37.181296, lat: 55.775479 },
      { lng: 37.182669, lat: 55.809064 },
      { lng: 37.225928, lat: 55.838378 },
      { lng: 37.269873, lat: 55.862277 },
      { lng: 37.313818, lat: 55.889241 },
      { lng: 37.357764, lat: 55.913877 },
      { lng: 37.392096, lat: 55.924651 },
    ],
  },
  moscow2: {
    cyrillicName: 'Москва 2',
    paths: [
      { lng: 37.095118, lat: 56.06865 },
      { lng: 37.207727, lat: 56.122273 },
      { lng: 37.328577, lat: 56.163588 },
      { lng: 37.465906, lat: 56.206386 },
      { lng: 37.603235, lat: 56.207913 },
      { lng: 37.853174, lat: 56.169704 },
      { lng: 38.006983, lat: 56.13758 },
      { lng: 38.127601, lat: 56.102014 },
      { lng: 38.218238, lat: 56.049897 },
      { lng: 38.355567, lat: 56.005388 },
      { lng: 38.468177, lat: 55.951603 },
      { lng: 38.564308, lat: 55.897743 },
      { lng: 38.575294, lat: 55.839181 },
      { lng: 38.57804, lat: 55.778987 },
      { lng: 38.512123, lat: 55.700131 },
      { lng: 38.435218, lat: 55.65367 },
      { lng: 38.366554, lat: 55.607154 },
      { lng: 38.397931, lat: 55.585664 },
      { lng: 38.406171, lat: 55.517303 },
      { lng: 38.362225, lat: 55.437918 },
      { lng: 38.321027, lat: 55.366179 },
      { lng: 38.002051, lat: 55.317407 },
      { lng: 37.807044, lat: 55.308028 },
      { lng: 37.551612, lat: 55.306465 },
      { lng: 37.395057, lat: 55.33147 },
      { lng: 37.301673, lat: 55.365827 },
      { lng: 37.222022, lat: 55.382994 },
      { lng: 37.118022, lat: 55.414188 },
      { lng: 36.96696, lat: 55.457817 },
      { lng: 36.890056, lat: 55.537162 },
      { lng: 36.859843, lat: 55.617898 },
      { lng: 36.810405, lat: 55.701564 },
      { lng: 36.785686, lat: 55.760333 },
      { lng: 36.782939, lat: 55.792772 },
      { lng: 36.807658, lat: 55.846778 },
      { lng: 36.796672, lat: 55.905328 },
      { lng: 36.788432, lat: 55.948414 },
      { lng: 36.859843, lat: 55.992988 },
      { lng: 37.008159, lat: 56.034441 },
      { lng: 37.085063, lat: 56.071252 },
    ],
  },
  piter: {
    cyrillicName: 'санкт-петербург',
    paths: [
      { lat: 59.992735, lng: 30.188684 },
      { lat: 60.027485, lng: 30.207566 },
      { lat: 60.047445, lng: 30.21028 },
      { lat: 60.061498, lng: 30.250842 },
      { lat: 60.068316, lng: 30.304057 },
      { lat: 60.083519, lng: 30.320698 },
      { lat: 60.09148, lng: 30.362295 },
      { lat: 60.084204, lng: 30.37105 },
      { lat: 60.07016, lng: 30.380835 },
      { lat: 60.073158, lng: 30.389246 },
      { lat: 60.061766, lng: 30.385641 },
      { lat: 60.05534, lng: 30.394568 },
      { lat: 60.04797, lng: 30.417742 },
      { lat: 60.04377, lng: 30.432676 },
      { lat: 60.040513, lng: 30.436281 },
      { lat: 60.037426, lng: 30.43714 },
      { lat: 59.993673, lng: 30.477137 },
      { lat: 59.984315, lng: 30.49602 },
      { lat: 59.97942, lng: 30.525202 },
      { lat: 59.975898, lng: 30.535673 },
      { lat: 59.970143, lng: 30.510954 },
      { lat: 59.947111, lng: 30.507521 },
      { lat: 59.892391, lng: 30.494818 },
      { lat: 59.887568, lng: 30.498938 },
      { lat: 59.875251, lng: 30.509752 },
      { lat: 59.870167, lng: 30.513014 },
      { lat: 59.864049, lng: 30.518679 },
      { lat: 59.860256, lng: 30.503229 },
      { lat: 59.864119, lng: 30.518329 },
      { lat: 59.859163, lng: 30.495927 },
      { lat: 59.860284, lng: 30.502879 },
      { lat: 59.854625, lng: 30.49377 },
      { lat: 59.846434, lng: 30.491967 },
      { lat: 59.835654, lng: 30.524239 },
      { lat: 59.832735, lng: 30.538675 },
      { lat: 59.835194, lng: 30.551163 },
      { lat: 59.835797, lng: 30.558408 },
      { lat: 59.834654, lng: 30.560168 },
      { lat: 59.830212, lng: 30.559431 },
      { lat: 59.826869, lng: 30.548745 },
      { lat: 59.819879, lng: 30.51437 },
      { lat: 59.824376, lng: 30.457207 },
      { lat: 59.83171, lng: 30.439354 },
      { lat: 59.823859, lng: 30.422703 },
      { lat: 59.820148, lng: 30.403477 },
      { lat: 59.817386, lng: 30.384422 },
      { lat: 59.816696, lng: 30.354725 },
      { lat: 59.812121, lng: 30.331207 },
      { lat: 59.817559, lng: 30.313355 },
      { lat: 59.829726, lng: 30.292755 },
      { lat: 59.837144, lng: 30.284859 },
      { lat: 59.838352, lng: 30.279194 },
      { lat: 59.835246, lng: 30.267349 },
      { lat: 59.82539, lng: 30.225242 },
      { lat: 59.823147, lng: 30.167907 },
      { lat: 59.825821, lng: 30.127738 },
      { lat: 59.828323, lng: 30.119155 },
      { lat: 59.860745, lng: 30.128425 },
      { lat: 59.873559, lng: 30.160182 },
      { lat: 59.896373, lng: 30.237606 },
      { lat: 59.904982, lng: 30.22559 },
      { lat: 59.923225, lng: 30.211857 },
      { lat: 59.934063, lng: 30.183876 },
      { lat: 59.943752, lng: 30.17268 },
      { lat: 59.961544, lng: 30.186069 },
      { lat: 59.989803, lng: 30.182121 },
      { lat: 59.992894, lng: 30.188129 },
    ],
  },
  kiev: {
    cyrillicName: 'київ',
    paths: [
      { lng: 30.553467, lat: 50.342399 },
      { lng: 30.543961, lat: 50.341523 },
      { lng: 30.542826, lat: 50.341494 },
      { lng: 30.541281, lat: 50.34148 },
      { lng: 30.540251, lat: 50.341562 },
      { lng: 30.538406, lat: 50.341863 },
      { lng: 30.536453, lat: 50.342014 },
      { lng: 30.535058, lat: 50.342123 },
      { lng: 30.533771, lat: 50.342123 },
      { lng: 30.531818, lat: 50.342178 },
      { lng: 30.530059, lat: 50.342192 },
      { lng: 30.528192, lat: 50.342082 },
      { lng: 30.526733, lat: 50.341877 },
      { lng: 30.526304, lat: 50.34174 },
      { lng: 30.525038, lat: 50.341343 },
      { lng: 30.524329, lat: 50.341096 },
      { lng: 30.523299, lat: 50.340535 },
      { lng: 30.522012, lat: 50.340042 },
      { lng: 30.521175, lat: 50.339658 },
      { lng: 30.519931, lat: 50.339261 },
      { lng: 30.518643, lat: 50.339056 },
      { lng: 30.517892, lat: 50.338919 },
      { lng: 30.516476, lat: 50.338946 },
      { lng: 30.514802, lat: 50.339083 },
      { lng: 30.51388, lat: 50.33922 },
      { lng: 30.512699, lat: 50.339631 },
      { lng: 30.508858, lat: 50.341274 },
      { lng: 30.505769, lat: 50.342548 },
      { lng: 30.503344, lat: 50.343753 },
      { lng: 30.501563, lat: 50.344931 },
      { lng: 30.500533, lat: 50.345903 },
      { lng: 30.499632, lat: 50.346944 },
      { lng: 30.497073, lat: 50.349797 },
      { lng: 30.495805, lat: 50.351058 },
      { lng: 30.493316, lat: 50.352564 },
      { lng: 30.489991, lat: 50.354056 },
      { lng: 30.487888, lat: 50.354522 },
      { lng: 30.486236, lat: 50.354754 },
      { lng: 30.485228, lat: 50.355042 },
      { lng: 30.483297, lat: 50.355261 },
      { lng: 30.480443, lat: 50.355685 },
      { lng: 30.478469, lat: 50.356069 },
      { lng: 30.476816, lat: 50.35652 },
      { lng: 30.474542, lat: 50.357684 },
      { lng: 30.473405, lat: 50.358437 },
      { lng: 30.472903, lat: 50.35872 },
      { lng: 30.471551, lat: 50.358166 },
      { lng: 30.471513, lat: 50.358138 },
      { lng: 30.470736, lat: 50.357923 },
      { lng: 30.470542, lat: 50.357936 },
      { lng: 30.469765, lat: 50.358121 },
      { lng: 30.468906, lat: 50.358391 },
      { lng: 30.46823, lat: 50.358604 },
      { lng: 30.467592, lat: 50.358802 },
      { lng: 30.467544, lat: 50.358812 },
      { lng: 30.467577, lat: 50.358846 },
      { lng: 30.467684, lat: 50.358976 },
      { lng: 30.467931, lat: 50.359287 },
      { lng: 30.468112, lat: 50.359714 },
      { lng: 30.468262, lat: 50.359998 },
      { lng: 30.468316, lat: 50.3601 },
      { lng: 30.468311, lat: 50.360114 },
      { lng: 30.46816, lat: 50.360114 },
      { lng: 30.467619, lat: 50.360135 },
      { lng: 30.466852, lat: 50.360159 },
      { lng: 30.466519, lat: 50.360176 },
      { lng: 30.466074, lat: 50.360207 },
      { lng: 30.465768, lat: 50.360224 },
      { lng: 30.465602, lat: 50.360218 },
      { lng: 30.465307, lat: 50.36019 },
      { lng: 30.46439, lat: 50.360368 },
      { lng: 30.463955, lat: 50.360433 },
      { lng: 30.463596, lat: 50.360494 },
      { lng: 30.46307, lat: 50.360583 },
      { lng: 30.462486, lat: 50.360693 },
      { lng: 30.461968, lat: 50.360784 },
      { lng: 30.461463, lat: 50.360862 },
      { lng: 30.461259, lat: 50.360869 },
      { lng: 30.460259, lat: 50.360939 },
      { lng: 30.459454, lat: 50.361035 },
      { lng: 30.458756, lat: 50.361069 },
      { lng: 30.458274, lat: 50.36111 },
      { lng: 30.45793, lat: 50.361137 },
      { lng: 30.457807, lat: 50.36111 },
      { lng: 30.457399, lat: 50.360925 },
      { lng: 30.457034, lat: 50.360795 },
      { lng: 30.456573, lat: 50.360603 },
      { lng: 30.454873, lat: 50.359926 },
      { lng: 30.454788, lat: 50.359657 },
      { lng: 30.454445, lat: 50.358672 },
      { lng: 30.454101, lat: 50.357714 },
      { lng: 30.453726, lat: 50.356954 },
      { lng: 30.453186, lat: 50.355833 },
      { lng: 30.452993, lat: 50.355463 },
      { lng: 30.452907, lat: 50.355278 },
      { lng: 30.45207, lat: 50.354676 },
      { lng: 30.450997, lat: 50.354772 },
      { lng: 30.450397, lat: 50.35484 },
      { lng: 30.44854, lat: 50.355114 },
      { lng: 30.446792, lat: 50.355394 },
      { lng: 30.444668, lat: 50.355763 },
      { lng: 30.442823, lat: 50.356037 },
      { lng: 30.441192, lat: 50.356338 },
      { lng: 30.439132, lat: 50.35668 },
      { lng: 30.437737, lat: 50.356954 },
      { lng: 30.43778, lat: 50.357803 },
      { lng: 30.437651, lat: 50.35961 },
      { lng: 30.436737, lat: 50.360302 },
      { lng: 30.435642, lat: 50.360973 },
      { lng: 30.436029, lat: 50.36215 },
      { lng: 30.436876, lat: 50.36451 },
      { lng: 30.437219, lat: 50.365701 },
      { lng: 30.437584, lat: 50.366714 },
      { lng: 30.437584, lat: 50.367193 },
      { lng: 30.437584, lat: 50.367548 },
      { lng: 30.437053, lat: 50.367941 },
      { lng: 30.436152, lat: 50.368433 },
      { lng: 30.435036, lat: 50.369131 },
      { lng: 30.434071, lat: 50.36961 },
      { lng: 30.432783, lat: 50.370363 },
      { lng: 30.432011, lat: 50.370828 },
      { lng: 30.43068, lat: 50.371827 },
      { lng: 30.432268, lat: 50.373194 },
      { lng: 30.433277, lat: 50.373906 },
      { lng: 30.43377, lat: 50.374248 },
      { lng: 30.433899, lat: 50.374412 },
      { lng: 30.434113, lat: 50.374727 },
      { lng: 30.435208, lat: 50.375644 },
      { lng: 30.436002, lat: 50.376424 },
      { lng: 30.436998, lat: 50.377345 },
      { lng: 30.43792, lat: 50.378098 },
      { lng: 30.438736, lat: 50.378809 },
      { lng: 30.439594, lat: 50.37948 },
      { lng: 30.439959, lat: 50.379931 },
      { lng: 30.441096, lat: 50.380396 },
      { lng: 30.44159, lat: 50.380698 },
      { lng: 30.442834, lat: 50.381341 },
      { lng: 30.44307, lat: 50.38145 },
      { lng: 30.44304, lat: 50.381608 },
      { lng: 30.44289, lat: 50.381799 },
      { lng: 30.442203, lat: 50.382374 },
      { lng: 30.440551, lat: 50.383551 },
      { lng: 30.438089, lat: 50.385387 },
      { lng: 30.43474, lat: 50.387893 },
      { lng: 30.431114, lat: 50.390547 },
      { lng: 30.429788, lat: 50.391509 },
      { lng: 30.428823, lat: 50.392277 },
      { lng: 30.428415, lat: 50.392606 },
      { lng: 30.427431, lat: 50.393392 },
      { lng: 30.426626, lat: 50.393994 },
      { lng: 30.425864, lat: 50.394527 },
      { lng: 30.424636, lat: 50.39529 },
      { lng: 30.423692, lat: 50.395817 },
      { lng: 30.421929, lat: 50.39659 },
      { lng: 30.42136, lat: 50.39687 },
      { lng: 30.420255, lat: 50.397329 },
      { lng: 30.418371, lat: 50.398016 },
      { lng: 30.415487, lat: 50.398989 },
      { lng: 30.414304, lat: 50.399411 },
      { lng: 30.41219, lat: 50.400095 },
      { lng: 30.410238, lat: 50.400758 },
      { lng: 30.407938, lat: 50.401502 },
      { lng: 30.406747, lat: 50.401926 },
      { lng: 30.405427, lat: 50.402336 },
      { lng: 30.403002, lat: 50.403161 },
      { lng: 30.400416, lat: 50.404053 },
      { lng: 30.399429, lat: 50.404415 },
      { lng: 30.398281, lat: 50.404777 },
      { lng: 30.397101, lat: 50.405195 },
      { lng: 30.395993, lat: 50.40557 },
      { lng: 30.394748, lat: 50.405987 },
      { lng: 30.393933, lat: 50.406342 },
      { lng: 30.392763, lat: 50.406958 },
      { lng: 30.391982, lat: 50.4074 },
      { lng: 30.390909, lat: 50.408091 },
      { lng: 30.38975, lat: 50.408822 },
      { lng: 30.388828, lat: 50.409376 },
      { lng: 30.385042, lat: 50.411732 },
      { lng: 30.380853, lat: 50.414382 },
      { lng: 30.376196, lat: 50.417308 },
      { lng: 30.372374, lat: 50.419716 },
      { lng: 30.369713, lat: 50.421575 },
      { lng: 30.368687, lat: 50.422549 },
      { lng: 30.367829, lat: 50.423629 },
      { lng: 30.367239, lat: 50.424306 },
      { lng: 30.366211, lat: 50.42572 },
      { lng: 30.36546, lat: 50.426917 },
      { lng: 30.364269, lat: 50.42842 },
      { lng: 30.363615, lat: 50.429035 },
      { lng: 30.362467, lat: 50.430512 },
      { lng: 30.361458, lat: 50.431852 },
      { lng: 30.360697, lat: 50.432911 },
      { lng: 30.360224, lat: 50.434131 },
      { lng: 30.360042, lat: 50.434924 },
      { lng: 30.359913, lat: 50.43558 },
      { lng: 30.359677, lat: 50.436803 },
      { lng: 30.359527, lat: 50.438478 },
      { lng: 30.359291, lat: 50.439708 },
      { lng: 30.359038, lat: 50.441318 },
      { lng: 30.35877, lat: 50.442801 },
      { lng: 30.358429, lat: 50.444819 },
      { lng: 30.358097, lat: 50.447033 },
      { lng: 30.357758, lat: 50.4493 },
      { lng: 30.357662, lat: 50.450755 },
      { lng: 30.357538, lat: 50.452328 },
      { lng: 30.357334, lat: 50.453667 },
      { lng: 30.357135, lat: 50.455023 },
      { lng: 30.356781, lat: 50.457065 },
      { lng: 30.356405, lat: 50.459439 },
      { lng: 30.355933, lat: 50.462479 },
      { lng: 30.355718, lat: 50.463776 },
      { lng: 30.355571, lat: 50.465708 },
      { lng: 30.355596, lat: 50.466518 },
      { lng: 30.355649, lat: 50.467112 },
      { lng: 30.355692, lat: 50.467553 },
      { lng: 30.355778, lat: 50.468151 },
      { lng: 30.355928, lat: 50.468806 },
      { lng: 30.356041, lat: 50.469307 },
      { lng: 30.356277, lat: 50.470048 },
      { lng: 30.356518, lat: 50.470765 },
      { lng: 30.356968, lat: 50.471981 },
      { lng: 30.357354, lat: 50.472882 },
      { lng: 30.357579, lat: 50.473466 },
      { lng: 30.357987, lat: 50.474504 },
      { lng: 30.358411, lat: 50.475586 },
      { lng: 30.358765, lat: 50.476449 },
      { lng: 30.359388, lat: 50.477843 },
      { lng: 30.359656, lat: 50.478376 },
      { lng: 30.360187, lat: 50.479256 },
      { lng: 30.360482, lat: 50.479949 },
      { lng: 30.360903, lat: 50.48089 },
      { lng: 30.361468, lat: 50.482249 },
      { lng: 30.361763, lat: 50.483014 },
      { lng: 30.362434, lat: 50.484556 },
      { lng: 30.363099, lat: 50.486068 },
      { lng: 30.363678, lat: 50.487502 },
      { lng: 30.364394, lat: 50.488993 },
      { lng: 30.365123, lat: 50.490758 },
      { lng: 30.365478, lat: 50.491942 },
      { lng: 30.36573, lat: 50.493464 },
      { lng: 30.365755, lat: 50.494608 },
      { lng: 30.365615, lat: 50.495611 },
      { lng: 30.365463, lat: 50.496866 },
      { lng: 30.36527, lat: 50.498245 },
      { lng: 30.365147, lat: 50.49918 },
      { lng: 30.365019, lat: 50.500146 },
      { lng: 30.364766, lat: 50.501445 },
      { lng: 30.364503, lat: 50.502699 },
      { lng: 30.364284, lat: 50.503864 },
      { lng: 30.364075, lat: 50.505044 },
      { lng: 30.363753, lat: 50.50661 },
      { lng: 30.363292, lat: 50.509043 },
      { lng: 30.363056, lat: 50.510114 },
      { lng: 30.362664, lat: 50.512028 },
      { lng: 30.362352, lat: 50.51374 },
      { lng: 30.362084, lat: 50.515341 },
      { lng: 30.36203, lat: 50.515617 },
      { lng: 30.362132, lat: 50.515675 },
      { lng: 30.362879, lat: 50.51558 },
      { lng: 30.364183, lat: 50.515484 },
      { lng: 30.365207, lat: 50.515535 },
      { lng: 30.36708, lat: 50.515863 },
      { lng: 30.367981, lat: 50.516122 },
      { lng: 30.36878, lat: 50.516408 },
      { lng: 30.369896, lat: 50.51677 },
      { lng: 30.370422, lat: 50.51691 },
      { lng: 30.371119, lat: 50.51706 },
      { lng: 30.371736, lat: 50.517145 },
      { lng: 30.372621, lat: 50.517231 },
      { lng: 30.373109, lat: 50.517265 },
      { lng: 30.374311, lat: 50.517374 },
      { lng: 30.374826, lat: 50.517398 },
      { lng: 30.375416, lat: 50.517439 },
      { lng: 30.376656, lat: 50.517531 },
      { lng: 30.377381, lat: 50.5176 },
      { lng: 30.378191, lat: 50.517668 },
      { lng: 30.379808, lat: 50.517775 },
      { lng: 30.380752, lat: 50.517847 },
      { lng: 30.382332, lat: 50.517952 },
      { lng: 30.383324, lat: 50.518037 },
      { lng: 30.384327, lat: 50.518116 },
      { lng: 30.385459, lat: 50.518194 },
      { lng: 30.387999, lat: 50.518388 },
      { lng: 30.389597, lat: 50.518504 },
      { lng: 30.391067, lat: 50.518617 },
      { lng: 30.392274, lat: 50.518699 },
      { lng: 30.393599, lat: 50.518798 },
      { lng: 30.395361, lat: 50.518935 },
      { lng: 30.395913, lat: 50.518989 },
      { lng: 30.396579, lat: 50.519027 },
      { lng: 30.397255, lat: 50.519095 },
      { lng: 30.398396, lat: 50.519197 },
      { lng: 30.399351, lat: 50.519272 },
      { lng: 30.400391, lat: 50.519361 },
      { lng: 30.401578, lat: 50.519449 },
      { lng: 30.402377, lat: 50.519507 },
      { lng: 30.403925, lat: 50.519621 },
      { lng: 30.404633, lat: 50.519675 },
      { lng: 30.405416, lat: 50.519709 },
      { lng: 30.405787, lat: 50.519737 },
      { lng: 30.406151, lat: 50.519744 },
      { lng: 30.406988, lat: 50.519802 },
      { lng: 30.408404, lat: 50.519904 },
      { lng: 30.410003, lat: 50.520023 },
      { lng: 30.410969, lat: 50.520119 },
      { lng: 30.41194, lat: 50.520194 },
      { lng: 30.412744, lat: 50.520255 },
      { lng: 30.414302, lat: 50.520376 },
      { lng: 30.415686, lat: 50.520482 },
      { lng: 30.417462, lat: 50.520608 },
      { lng: 30.419887, lat: 50.520788 },
      { lng: 30.422183, lat: 50.520952 },
      { lng: 30.424109, lat: 50.521106 },
      { lng: 30.424833, lat: 50.521198 },
      { lng: 30.425901, lat: 50.521348 },
      { lng: 30.426619, lat: 50.521494 },
      { lng: 30.427959, lat: 50.521957 },
      { lng: 30.42878, lat: 50.522329 },
      { lng: 30.429727, lat: 50.522898 },
      { lng: 30.430547, lat: 50.523481 },
      { lng: 30.431237, lat: 50.523987 },
      { lng: 30.431921, lat: 50.524416 },
      { lng: 30.432425, lat: 50.524655 },
      { lng: 30.432897, lat: 50.52487 },
      { lng: 30.433359, lat: 50.525061 },
      { lng: 30.434229, lat: 50.525352 },
      { lng: 30.434905, lat: 50.525519 },
      { lng: 30.435345, lat: 50.525601 },
      { lng: 30.436188, lat: 50.525717 },
      { lng: 30.436977, lat: 50.525772 },
      { lng: 30.437663, lat: 50.525826 },
      { lng: 30.439061, lat: 50.525932 },
      { lng: 30.439603, lat: 50.525946 },
      { lng: 30.440376, lat: 50.526017 },
      { lng: 30.441561, lat: 50.52612 },
      { lng: 30.443267, lat: 50.526287 },
      { lng: 30.444748, lat: 50.526433 },
      { lng: 30.446207, lat: 50.526587 },
      { lng: 30.447467, lat: 50.526706 },
      { lng: 30.448782, lat: 50.526856 },
      { lng: 30.45053, lat: 50.527047 },
      { lng: 30.451829, lat: 50.52719 },
      { lng: 30.452521, lat: 50.527272 },
      { lng: 30.453137, lat: 50.527337 },
      { lng: 30.45347, lat: 50.527378 },
      { lng: 30.454339, lat: 50.527456 },
      { lng: 30.455348, lat: 50.527507 },
      { lng: 30.456879, lat: 50.527527 },
      { lng: 30.45778, lat: 50.527438 },
      { lng: 30.458488, lat: 50.527333 },
      { lng: 30.459145, lat: 50.527226 },
      { lng: 30.460078, lat: 50.527065 },
      { lng: 30.46092, lat: 50.526919 },
      { lng: 30.462187, lat: 50.526688 },
      { lng: 30.462772, lat: 50.526606 },
      { lng: 30.46377, lat: 50.526487 },
      { lng: 30.464521, lat: 50.52647 },
      { lng: 30.464896, lat: 50.526494 },
      { lng: 30.465336, lat: 50.526562 },
      { lng: 30.465824, lat: 50.526627 },
      { lng: 30.466211, lat: 50.526749 },
      { lng: 30.466549, lat: 50.526876 },
      { lng: 30.466838, lat: 50.527009 },
      { lng: 30.467058, lat: 50.527152 },
      { lng: 30.46731, lat: 50.527298 },
      { lng: 30.4677, lat: 50.527543 },
      { lng: 30.467882, lat: 50.527696 },
      { lng: 30.468097, lat: 50.52788 },
      { lng: 30.468381, lat: 50.528068 },
      { lng: 30.46866, lat: 50.528279 },
      { lng: 30.468864, lat: 50.528388 },
      { lng: 30.469009, lat: 50.528464 },
      { lng: 30.469287, lat: 50.528576 },
      { lng: 30.469815, lat: 50.528751 },
      { lng: 30.470137, lat: 50.528833 },
      { lng: 30.470603, lat: 50.528931 },
      { lng: 30.471065, lat: 50.528993 },
      { lng: 30.471494, lat: 50.529024 },
      { lng: 30.471885, lat: 50.529054 },
      { lng: 30.472475, lat: 50.529058 },
      { lng: 30.473399, lat: 50.529082 },
      { lng: 30.474048, lat: 50.529102 },
      { lng: 30.47504, lat: 50.529123 },
      { lng: 30.483739, lat: 50.52928 },
      { lng: 30.487394, lat: 50.528768 },
      { lng: 30.496916, lat: 50.528866 },
      { lng: 30.50846, lat: 50.529043 },
      { lng: 30.508717, lat: 50.529295 },
      { lng: 30.512322, lat: 50.529486 },
      { lng: 30.513738, lat: 50.529479 },
      { lng: 30.517257, lat: 50.529479 },
      { lng: 30.51833, lat: 50.529193 },
      { lng: 30.519071, lat: 50.528238 },
      { lng: 30.519886, lat: 50.527154 },
      { lng: 30.520246, lat: 50.526561 },
      { lng: 30.530482, lat: 50.526616 },
      { lng: 30.539551, lat: 50.522737 },
      { lng: 30.537148, lat: 50.51728 },
      { lng: 30.536118, lat: 50.515315 },
      { lng: 30.533887, lat: 50.50942 },
      { lng: 30.53423, lat: 50.504071 },
      { lng: 30.534573, lat: 50.500358 },
      { lng: 30.53526, lat: 50.49741 },
      { lng: 30.536462, lat: 50.495444 },
      { lng: 30.538178, lat: 50.493588 },
      { lng: 30.538865, lat: 50.492605 },
      { lng: 30.540753, lat: 50.490749 },
      { lng: 30.543156, lat: 50.488783 },
      { lng: 30.545216, lat: 50.487254 },
      { lng: 30.545903, lat: 50.485834 },
      { lng: 30.545903, lat: 50.482448 },
      { lng: 30.54556, lat: 50.480482 },
      { lng: 30.544015, lat: 50.477751 },
      { lng: 30.540066, lat: 50.474364 },
      { lng: 30.536633, lat: 50.471851 },
      { lng: 30.534402, lat: 50.469885 },
      { lng: 30.53217, lat: 50.467481 },
      { lng: 30.531655, lat: 50.464858 },
      { lng: 30.531998, lat: 50.462564 },
      { lng: 30.532857, lat: 50.460597 },
      { lng: 30.534573, lat: 50.458328 },
      { lng: 30.537148, lat: 50.456798 },
      { lng: 30.541268, lat: 50.455705 },
      { lng: 30.542813, lat: 50.455049 },
      { lng: 30.545731, lat: 50.454066 },
      { lng: 30.547448, lat: 50.452864 },
      { lng: 30.550709, lat: 50.452098 },
      { lng: 30.551911, lat: 50.451333 },
      { lng: 30.553971, lat: 50.450677 },
      { lng: 30.555173, lat: 50.450131 },
      { lng: 30.556889, lat: 50.449147 },
      { lng: 30.558434, lat: 50.448382 },
      { lng: 30.559293, lat: 50.447945 },
      { lng: 30.561696, lat: 50.447617 },
      { lng: 30.565472, lat: 50.447508 },
      { lng: 30.569249, lat: 50.448382 },
      { lng: 30.572682, lat: 50.448491 },
      { lng: 30.57663, lat: 50.449147 },
      { lng: 30.57972, lat: 50.449694 },
      { lng: 30.580922, lat: 50.450022 },
      { lng: 30.58075, lat: 50.450787 },
      { lng: 30.580493, lat: 50.451771 },
      { lng: 30.580149, lat: 50.452372 },
      { lng: 30.57972, lat: 50.453027 },
      { lng: 30.579634, lat: 50.454011 },
      { lng: 30.579806, lat: 50.455049 },
      { lng: 30.579119, lat: 50.456033 },
      { lng: 30.578519, lat: 50.456689 },
      { lng: 30.577832, lat: 50.457345 },
      { lng: 30.576888, lat: 50.457454 },
      { lng: 30.575944, lat: 50.458055 },
      { lng: 30.575772, lat: 50.458164 },
      { lng: 30.576201, lat: 50.458492 },
      { lng: 30.582381, lat: 50.459421 },
      { lng: 30.585728, lat: 50.460459 },
      { lng: 30.588818, lat: 50.460896 },
      { lng: 30.591737, lat: 50.461607 },
      { lng: 30.593625, lat: 50.46188 },
      { lng: 30.594826, lat: 50.462098 },
      { lng: 30.59105, lat: 50.467234 },
      { lng: 30.584698, lat: 50.474937 },
      { lng: 30.580922, lat: 50.478979 },
      { lng: 30.578175, lat: 50.481218 },
      { lng: 30.57663, lat: 50.482092 },
      { lng: 30.575, lat: 50.482693 },
      { lng: 30.574251, lat: 50.483879 },
      { lng: 30.574251, lat: 50.484862 },
      { lng: 30.574165, lat: 50.48661 },
      { lng: 30.573993, lat: 50.489176 },
      { lng: 30.573736, lat: 50.490541 },
      { lng: 30.567899, lat: 50.491306 },
      { lng: 30.560518, lat: 50.489832 },
      { lng: 30.5576, lat: 50.489613 },
      { lng: 30.555883, lat: 50.492343 },
      { lng: 30.555797, lat: 50.493818 },
      { lng: 30.555454, lat: 50.496111 },
      { lng: 30.555797, lat: 50.497203 },
      { lng: 30.555626, lat: 50.498513 },
      { lng: 30.556141, lat: 50.499496 },
      { lng: 30.556312, lat: 50.50026 },
      { lng: 30.557171, lat: 50.500697 },
      { lng: 30.559574, lat: 50.502226 },
      { lng: 30.561462, lat: 50.503208 },
      { lng: 30.561462, lat: 50.503754 },
      { lng: 30.563179, lat: 50.508667 },
      { lng: 30.561634, lat: 50.512925 },
      { lng: 30.562835, lat: 50.516308 },
      { lng: 30.559745, lat: 50.516418 },
      { lng: 30.559231, lat: 50.517727 },
      { lng: 30.558201, lat: 50.518601 },
      { lng: 30.557857, lat: 50.519256 },
      { lng: 30.556827, lat: 50.52002 },
      { lng: 30.555969, lat: 50.520784 },
      { lng: 30.555111, lat: 50.521548 },
      { lng: 30.554596, lat: 50.522202 },
      { lng: 30.550991, lat: 50.522093 },
      { lng: 30.546871, lat: 50.522202 },
      { lng: 30.542751, lat: 50.522202 },
      { lng: 30.539833, lat: 50.522857 },
      { lng: 30.540953, lat: 50.522741 },
      { lng: 30.554823, lat: 50.522127 },
      { lng: 30.574117, lat: 50.529843 },
      { lng: 30.592786, lat: 50.536554 },
      { lng: 30.598877, lat: 50.536308 },
      { lng: 30.614798, lat: 50.535353 },
      { lng: 30.622351, lat: 50.535026 },
      { lng: 30.623532, lat: 50.535792 },
      { lng: 30.628571, lat: 50.528927 },
      { lng: 30.626511, lat: 50.507315 },
      { lng: 30.644192, lat: 50.486022 },
      { lng: 30.655007, lat: 50.467669 },
      { lng: 30.682093, lat: 50.457943 },
      { lng: 30.658329, lat: 50.430421 },
      { lng: 30.670517, lat: 50.428179 },
      { lng: 30.679186, lat: 50.426758 },
      { lng: 30.693954, lat: 50.424035 },
      { lng: 30.703223, lat: 50.422394 },
      { lng: 30.709746, lat: 50.418238 },
      { lng: 30.681594, lat: 50.402813 },
      { lng: 30.553467, lat: 50.342399 },
    ],
  },
}

export const inPoly = (object, polygon) => {
  const { lat: y, lng: x } = object
  const point = { x, y }

  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const vertex1 = { x: polygon[i].lng, y: polygon[i].lat }
    const vertex2 = { x: polygon[j].lng, y: polygon[j].lat }
    const intersect =
      vertex1.y > point.y !== vertex2.y > point.y &&
      point.x <
      ((vertex2.x - vertex1.x) * (point.y - vertex1.y)) /
      (vertex2.y - vertex1.y) +
      vertex1.x
    if (intersect) {
      inside = !inside
    }
  }
  return inside
}

export const courierMskZone = (coordinates) => {
  const inPoly1 = inPoly(coordinates, polygons.moscow.paths)
  const inPoly2 = inPoly(coordinates, polygons.moscow1.paths)
  const inPoly3 = inPoly(coordinates, polygons.moscow2.paths)
  if (inPoly1) return 'Москва'
  if (inPoly2) return 'Москва (за МКАД)'
  if (inPoly3) return 'Москва 2'
}

// export const matchCityWithExpressDelivery = (currentCity) =>
//   Object.values(polygons).find(
//     (city) => city.cyrillicName.toLowerCase() === currentCity.toLowerCase()
//   )

export const getIsCoordsInPolygons = (currentCity, currentCoords) => {
  const matchCityWithExpressDelivery = Object.values(polygons).find(
    (city) => city.cyrillicName.toLowerCase() === currentCity.toLowerCase()
  )
  if (!matchCityWithExpressDelivery) return
  return !inPoly(currentCoords, matchCityWithExpressDelivery.paths)
}
